import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: resolve => require(['@/components/HelloWorld'], resolve),
    },
    {
      path: '/test',
      name: 'landingPage',
      component: resolve => require(['@/components/landingPage'], resolve),
    },
    {
      path: '/resetPass',
      name: 'resetPass',
      component: resolve => require(['@/components/resetPass'], resolve),
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/components/login'], resolve),
    },
    {
      path: '/profile',
      name: 'Profile',
      component: resolve => require(['@/components/profile'], resolve),
    },
    {
      path: '/mainpage',
      name: 'mainPage',
      component: resolve => require(['@/components/appbar'], resolve),
      children: [
        {
          path: '/mainpage',
          name: 'mainpage',
          component: resolve => require(['@/components/mainPage'], resolve),
        },
        {
          path: '/chatbot',
          name: 'chatbot',
          component: resolve => require(['@/components/chatBot'], resolve),
        },
        {
          path: '/emc',
          name: 'emc',
          component: resolve => require(['@/components/shop'], resolve),
        },
        {
          path: '/shoplist',
          name: 'shoplist',
          component: resolve => require(['@/components/shoplist'], resolve),
        },
        {
          path: '/profile',
          name: 'profile',
          component: resolve => require(['@/components/profile'], resolve),
        },
        {
          path: '/billing/:service/:id',
          name: 'billing',
          component: resolve => require(['@/components/member/payment'], resolve),
        },
        {
          path: '/member/:service/:id',
          name: 'member',
          component: resolve => require(['@/components/member/member'], resolve),
        },
        {
          path: '/booking/:service/:id',
          name: 'booking',
          component: resolve => require(['@/components/member/booking'], resolve),
        },
        {
          path: '/dataAna/:service/:id',
          name: 'dataAna',
          component: resolve => require(['@/components/member/dataAnalysis'], resolve),
        },
        {
          path: '/secretPath/:service/:id',
          name: 'secretPath',
          component: resolve => require(['@/components/member/secretPath'], resolve),
        },
        {
          path: '/script/:service/:id',
          name: 'script',
          component: resolve => require(['@/components/member/script'], resolve),
        },
        {
          path: '/broadcast/:service/:id',
          name: 'broadcast',
          component: resolve => require(['@/components/member/broadcast'], resolve),
        },
        {
          path: '/coadmin/:service/:id',
          name: 'coadmin',
          component: resolve => require(['@/components/member/coadmin'], resolve),
        },
        {
          path: '/setting/:service/:id',
          name: 'setting',
          component: resolve => require(['@/components/member/setting'], resolve),
        },
        {
          path: '/store/:service/:id',
          name: 'store',
          component: resolve => require(['@/components/member/store'], resolve),
        },
        {
          path: '/ecshop/:service/:id',
          name: 'ecshop',
          component: resolve => require(['@/components/member/ECshop'], resolve),
        }
      ],
    },
  ]
})

export default router;